<template>
  <div class="outages-list" v-bind:class="{isDarkMode: isDarkMode}">
    <div class="tabs-container">
      <ul class="tabs">
        <li
        class="tab"
        v-on:click="selectTab('county')"
        v-bind:class="{selected: selectedTab === 'county'}">County</li>
        <li
        class="tab"
        v-on:click="selectTab('town')"
        v-bind:class="{selected: selectedTab === 'town'}">Town</li>
        <li
        class="tab"
        v-on:click="selectTab('utility')"
        v-bind:class="{selected: selectedTab === 'utility'}">Utility</li>
      </ul>
    </div>
    <outages-list-search
    v-bind:selectedTab="selectedTab"
    :isDarkMode="isDarkMode"
    :searchChange="onSearchChange"></outages-list-search>
    <outages-list-county
    :countyOutages="countyOutages"
    v-if="selectedTab === 'county' && countyOutages && countyOutages.length"></outages-list-county>
    <outages-list-town
    :townOutages="townOutages"
    v-if="selectedTab === 'town' && townOutages && townOutages.length"></outages-list-town>
    <outages-list-utility
    :utilityOutages="utilityOutages"
    v-if="selectedTab === 'utility' && utilityOutages && utilityOutages.length"></outages-list-utility>
  </div>
</template>

<script>
import OutagesListTown from "../outages-list/OutagesListTown";
import OutagesListCounty from "../outages-list/OutagesListCounty";
import OutagesListUtility from "../outages-list/OutagesListUtility";
import OutagesListSearch from "../outages-list/OutagesListSearch";

export default {
  name: 'OutagesList',
    components: {
    OutagesListTown,
    OutagesListCounty,
    OutagesListUtility,
    OutagesListSearch,
  },
  props: {
    isDarkMode: Boolean,
    selectedTab: String,
    selectTab: Function,
    utilityOutages: Array,
    townOutages: Array,
    countyOutages: Array,
    restoreData: Function,
    filterCountyData: Function,
    filterTownData: Function,
    filterUtilityData: Function,
  },
  methods: {
    onSearchChange(searchString) {
      if (!searchString || !searchString.length) {
        this.restoreData();
        return
      }

      switch(this.selectedTab) {
        case 'county':
         this.filterCountyData(searchString);
        break;
        case 'town':
          this.filterTownData(searchString);
        break;
        case 'utility':
          this.filterUtilityData(searchString);
        break;
      }

      this.$forceUpdate();
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.outages-list{
    margin: 0 auto;
    padding-top: 20px;
    width: 100%;
    text-align: center;
    border-top: 1px solid $greyTextTrans65;

    &.isDarkMode {
      border-top: 1px solid $greyTextTrans25;
    }

  .tabs-container{
    .tabs{
      list-style-type: none;
      margin: -1px 0 0 0;
      padding: 0;

      .tab{
        list-style-type: none;
        width: 33.3%;
        margin: 0;
        padding: 0;
        display: inline-block;
        text-transform: uppercase;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: $greyTextTrans65;

        &:hover{
          cursor: pointer;
        }

        &.selected{
          font-weight: 700;
          color: #fff;
        }
      }
    }
  }
}
</style>
